import { render, staticRenderFns } from "./QPieChartGeneric.vue?vue&type=template&id=4b05da76&scoped=true&"
import script from "./QPieChartGeneric.vue?vue&type=script&lang=js&"
export * from "./QPieChartGeneric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b05da76",
  null
  
)

export default component.exports